import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Fields, FormSection } from 'redux-form';
import { propShape } from '../../../../../helpers/custom-prop-types';
import { consultantValidate } from '../../../../../validate/custom/profile';
import CategoryMiddleFieldsAndLabel from '../../../../Ui/Profile/Hook/CategoryMiddleSingleFieldsAndLabel';
const MiddleTaskPartsMiddleColumnComponent = (props) => {
    const { middleTask } = props;
    const { isOther, name } = middleTask;
    const { name: fieldName, validate } = useMemo(() => ({
        name: ['check', 'other', 'especially'],
        validate: {
            other: isOther ? consultantValidate.middleTask.other : [],
        },
    }), [isOther]);
    return (_jsx(FormSection, Object.assign({ name: `middleTasks.${middleTask.id}` }, { children: _jsx(Fields, { component: CategoryMiddleFieldsAndLabel, disabled: false, middleIsOther: !!isOther, middleName: name, names: fieldName, otherMiddleClassName: '', validate: validate, wrapMiddleClassName: '' }) })));
};
MiddleTaskPartsMiddleColumnComponent.propTypes = {
    middleTask: propShape().isRequired,
};
export default MiddleTaskPartsMiddleColumnComponent;
